/** Matches a v4-ish UUID (8-4-4-4-12 hex). Used to recognise legacy
 *  uuid-only hrefs that predate the `nula://document/` scheme. */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Extract the document ID from a document-type link href.
 *
 * Accepts `nula://document/<uuid>` href values; bare UUIDs are also
 * recognised as a legacy shorthand. Returns `null` for any other input.
 *
 * Pure URL parser — no dependencies on editor / Lexical / runtime state.
 * Lives in lib/documents so editor, components, and feature consumers
 * (e.g. assistant link rendering) can all share it.
 */
export function extractDocumentId(href: string): string | null {
  if (href.startsWith('nula://document/')) return href.replace('nula://document/', '');
  if (UUID_RE.test(href)) return href;
  return null;
}
